import { useNavigate } from "react-router-dom";

const NoCylinderAtFactory = (props) => {
    const navigate = useNavigate()
  return (
    <div className="flex flex-col items-center justify-center text-center rounded-xl form-container">
      {/* Title */}
      <h2 className="text-xl font-semibold text-stone-800">
        No Cylinders Available
      </h2>

      {/* Description */}
      <p className="text-sm text-stone-500 mt-2 max-w-md">
        There are currently no cylinders available at the factory for job card
        processing. Once a cylinder arrives at the factory, it will appear here
        automatically.
      </p>

      {/* Info Box */}
      <div className="mt-6 bg-blue-100 border border-blue-200 text-blue-700 text-xs rounded-md px-4 py-3">
        Please ensure cylinders have been properly transferred to the factory
        before creating a job card.
      </div>
      <button className="mt-6 px-4 py-2 text-sm bg-dBlue-100 text-dark-blue rounded-md hover:bg-gray-200 transition" onClick={() => navigate(0)}>
        Refresh
      </button>
    </div>
  );
};

export default NoCylinderAtFactory;
